import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { PageHeading } from "../../components/pageHeading";
import {
  SEARCH_SECTIONS,
  SearchSectionHeading,
  SearchResultItem,
} from "../../components/search";
import { useGlobalSearch } from "../../hooks/useGlobalSearch";

function SearchResults() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q") || "";

  const { results, totalCount, isLoading, ensureData } =
    useGlobalSearch(query);

  useEffect(() => {
    ensureData();
  }, [ensureData]);

  return (
    <div>
      <main className="py-6">
        <div className="px-4 sm:px-6 lg:px-6">
          <PageHeading title="Search results" />

          {query.trim().length > 0 && (
            <p className="mb-4 pl-1 text-sm text-gray-500 dark:text-gray-400">
              {isLoading
                ? "Searching..."
                : `${totalCount} result${totalCount === 1 ? "" : "s"} for "${query}"`}
            </p>
          )}

          {isLoading ? null : query.trim().length === 0 ? (
            <div className="flex flex-col items-center justify-center h-96">
              <MagnifyingGlassIcon className="h-10 w-10 text-gray-300 dark:text-gray-600" />
              <p className="mt-3 text-sm text-gray-400 dark:text-gray-500 text-center">
                Type in the search bar above to find sites, customers and
                users
              </p>
            </div>
          ) : totalCount === 0 ? (
            <div className="flex flex-col items-center justify-center h-96">
              <MagnifyingGlassIcon className="h-10 w-10 text-gray-300 dark:text-gray-600" />
              <p className="mt-3 text-sm text-gray-400 dark:text-gray-500 text-center">
                No results found for "{query}"
              </p>
            </div>
          ) : (
            <div className="max-w-2xl divide-y divide-gray-100 dark:divide-gray-800">
              {SEARCH_SECTIONS.map((section) => {
                const items = results[section.key];
                if (items.length === 0) return null;
                return (
                  <div key={section.key} className="py-3">
                    <SearchSectionHeading section={section} />
                    {items.map((item) => (
                      <SearchResultItem
                        key={item.id}
                        section={section}
                        item={item}
                        onSelect={(path) => navigate(path)}
                      />
                    ))}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export { SearchResults };
